/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WarehouseDimension {
  Item = 'Item',
  Pallet = 'Pallet',
  Batch = 'Batch',
  Serial = 'Serial'
}
